const $ = window.jQuery;
import "jquery-sparkline";

import { fromLonLat, toLonLat } from "ol/proj.js";
import LineString from "ol/geom/LineString.js";
import { heatmap } from "./hm.js";

const { OUTAGE_CONFIG } = window.appConfig;

export function DrillDown(
  map,
  pois,
  popup,
  overlay,
  state,
  ddTypes = ["ptli", "dtli", "isp"],
  defaultType = "dtli",
) {
  this.map = map;
  this.pois = pois;
  this.popup = popup;
  this.overlay = overlay;
  this.state = state;
  this.defType = defaultType;
  this.lonlat = null;
  this.coordStr = "";
  this.popupContentTable = document.getElementById("dd-data-table");
  this.tabsObjList = [];
  this.tabsObjDict = {};
  this.activeTab = -1;
  this.jqTabs = $("<div>", { id: "tabs" }).appendTo(this.popup);
  this.jqTabsUL = $("<ul>", { id: "tabs-list" }).appendTo(this.jqTabs);
  this.jqTabsCt = $("<div>", { id: "tabs-container" }).appendTo(this.jqTabs);
  this.jqTimeout = $('<div class="dd-timeout-block">Connection Timedout</div>')
    .appendTo(this.popup)
    .hide();
  this.jqTimeoutRetry = $(
    '<button type="button" class="dd-timeout-retry">Retry &#10227;</button>',
  ).appendTo(this.jqTimeout);
  var dd = this;
  this.jqTimeoutRetry.click(function () {
    dd.tabsObjList[dd.activeTab].doDD(dd.lonlat);
  });

  ddTypes.forEach(this.addTab.bind(this));

  this.popupCloser = $(
    '<a href="#" id="popup-closer" class="ol-popup-closer"></a>',
  ).appendTo(this.popup);

  $(function () {
    dd.jqTabs.tabs({
      activate: function () {
        dd.activeTab = dd.jqTabs.tabs("option", "active");
        dd.tabsObjList[dd.activeTab].doDD(dd.lonlat);
      },
    });
  });

  if (state.ddown === undefined || state.ddown === null) state.ddown = {};

  this.setHeatmap(OUTAGE_CONFIG["colorScale"], 10);

  // Add a click handler to hide the popup.
  this.popupCloser.click(this.closePopup.bind(this));
}

DrillDown.DAYSECONDS = 24 * 60 * 60;
DrillDown.URL = "includes/ddown.py";

DrillDown.TABS = {
  ptli: {
    idx: -1,
    ddtype: "ptli",
    database: null,
    ddownJSON: {},
    install: function (dd, idx) {
      this.dd = dd;
      this.idx = idx;
      this.jqLI = $(
        `<li><a href="#tabs-ptli-${idx}">Quarter Timeline</a></li>`,
      ).appendTo(dd.jqTabsUL);
      //xxx too much here?
      this.jqCt = $(`
        <div id="tabs-ptli-${idx}" class="dd-tabs-ptli">
          <div id="tabs-ptli-${idx}-location" class="dd-tabs-location"></div>
          <div id="tabs-ptli-${idx}-blocks" class="dd-tabs-blocks"></div>
          <br>
          <span id="tabs-ptli-${idx}-spark" class="dd-dynamicsparkline"></span>
          <pre id="tabs-ptli-${idx}-x-axis-labels" class="dd-dynamicsparkline-labels"></pre>
        </div>`).appendTo(dd.jqTabsCt);
      this.jqLocation = $(`#tabs-ptli-${idx}-location`);
      this.jqBlocks = $(`#tabs-ptli-${idx}-blocks`);
      this.jqSpark = $(`#tabs-ptli-${idx}-spark`);
      this.jqSparkLabels = $(`#tabs-ptli-${idx}-x-axis-labels`);
    },
    updateBlocks: function (blocks_change, blocks_total) {
      this.jqLocation.html(
        `Location: ${this.dd.coordStr} (${this.dd.state.grid}deg)`,
      );
      if (blocks_change !== null) {
        this.jqBlocks.html(
          `Down: ${blocks_change} / ${blocks_total}
           blocks (${((blocks_change * 100) / blocks_total).toFixed(2)}%)`,
        );
      } else {
        this.jqBlocks.html("Down: --/--");
      }
    },
    clear: function () {
      this.jqSpark.empty();
      this.jqSpark.html("Loading...");
      this.updateBlocks(null, null);
      this.jqSparkLabels.html("");
      this.ddownJSON = {};
    },
    updateContentTS: function (ts) {
      const dd = this.dd;
      if (
        this.database !== dd.state.database ||
        this.ddownJSON.dat === undefined
      ) {
        //deal with time-travel outside of the db
        this.ddownJSON = {};
        this.doDD(dd.lonlat);
        return;
      }
      var currentDat = null;
      if (this.ddownJSON.dat !== undefined) {
        for (const d of this.ddownJSON.dat) {
          //.dat: [[ts, "date", downcount],...]
          if (d === null) continue;
          if (
            Math.floor(d[0] / DrillDown.DAYSECONDS) ==
            Math.floor(ts / DrillDown.DAYSECONDS)
          ) {
            currentDat = d;
            break;
          }
        }
      }
      if (currentDat !== null) {
        this.updateBlocks(currentDat[1], currentDat[2]);
      } else {
        //xxx deal with nulls and database change
        this.updateBlocks(null, null);
      }
    },
    doDD: function (ll) {
      if (ll === null) return;
      const dd = this.dd;
      //xxx make sure use the same lon,lat order as in map
      const ts = dd.state.timestamp;
      const [lon, lat] = ll;
      dd.setLocation(ll);
      const jdata = this.ddownJSON;
      if (
        Math.abs(jdata.lat - lat) <= dd.state.grid / 2 &&
        Math.abs(jdata.lon - lon) <= dd.state.grid / 2
      ) {
        this.updateContentTS(ts); //still need to update sparkline text
        return;
      }
      this.clear();
      this.database = dd.state.database; //xxx db should be returned by ajax
      dd.callAJAX(lat, lon, ts, "ptli", this.ddCallback.bind(this));
    },
    ddCallback: function (ddown_json) {
      //make sure min and max are aligned to a day's boundary
      const minTs =
        this.dd.state.dbMinTS - (this.dd.state.dbMinTS % DrillDown.DAYSECONDS);
      const maxTs =
        this.dd.state.dbMaxTS - (this.dd.state.dbMaxTS % DrillDown.DAYSECONDS);
      const rndTs =
        this.dd.state.timestamp -
        (this.dd.state.timestamp % DrillDown.DAYSECONDS);
      const sldata = DrillDown.makeSLdata(
        minTs,
        maxTs,
        DrillDown.DAYSECONDS,
        ddown_json.dat,
      );
      // Displaying words in popup
      if (sldata.oCount[rndTs] !== null) {
        this.dd.updateContentTimeline(
          sldata.oCount[rndTs][1],
          sldata.oCount[rndTs][2],
        );
      } else {
        console.log(rndTs, minTs, maxTs, sldata.oCount);
      }
      this.ddownJSON = ddown_json;
      var sparkline = this.dd.addSparkline(
        sldata.barChart,
        sldata.allValues,
        ddown_json,
        this.jqSpark,
        "ptli",
      );
      // add x-axis labels
      const min_date = new Date(minTs * 1000)
        .toISOString()
        .substr(0, 16)
        .split("T")[0];
      const max_date = new Date(maxTs * 1000)
        .toISOString()
        .substr(0, 16)
        .split("T")[0];
      this.jqSparkLabels.html(
        `<p style="float:left;">${min_date}</p><p style="float:right;">${max_date}</p>`,
      );
      sparkline.unbind("sparklineClick"); //don't want to bind multiple times
      sparkline.bind(
        "sparklineClick",
        function (ev) {
          var region = ev.sparklines[0].getCurrentRegionFields();
          var click_dd = ddown_json.dat[region[0].offset];
          if (click_dd !== null) {
            var click_ts = click_dd[0];
            this.dd.timeTravel(click_ts);
          }
          this.dd.tabsObjList[this.dd.activeTab].doDD(this.dd.lonlat);
        }.bind(this),
      );
    },
  },
  dtli: {
    idx: -1,
    ddtype: "dtli",
    timestamp: -1,
    ddownJSON: {},
    install: function (dd, idx) {
      this.dd = dd;
      this.idx = idx;
      this.jqLI = $(
        `<li><a href="#tabs-dtli-${idx}">Daily Timeline</a></li>`,
      ).appendTo(dd.jqTabsUL);
      //xxx too much here
      this.jqCt = $(`
        <div id="tabs-dtli-${idx}" class="dd-tabs-dtli">
          <div id="tabs-dtli-${idx}-location" class="dd-tabs-location"></div>
          <div id="tabs-dtli-${idx}-blocks" class="dd-tabs-blocks"></div>
          <br>
          <span id="tabs-dtli-${idx}-spark" class="dd-dynamicsparkline"></span>
          <pre id="tabs-dtli-${idx}-x-axis-labels" class="dd-dynamicsparkline-labels"></pre>
        </div>`).appendTo(dd.jqTabsCt);
      this.jqLocation = $(`#tabs-dtli-${idx}-location`);
      this.jqBlocks = $(`#tabs-dtli-${idx}-blocks`);
      this.jqSpark = $(`#tabs-dtli-${idx}-spark`);
      this.jqSparkLabels = $(`#tabs-dtli-${idx}-x-axis-labels`);
    },
    updateBlocks: function (blocks_change, blocks_total) {
      this.jqLocation.html(
        `Location: ${this.dd.coordStr} (${this.dd.state.grid}deg)`,
      );
      if (blocks_change !== null) {
        this.jqBlocks.html(
          `Down: ${blocks_change} / ${blocks_total}
           blocks (${((blocks_change * 100) / blocks_total).toFixed(2)}%)`,
        );
      } else {
        this.jqBlocks.html("Down: --/--");
      }
    },
    clear: function () {
      this.jqSpark.empty();
      this.jqSpark.html("Loading...");
      this.updateBlocks(null, null);
      this.jqSparkLabels.html("");
      this.ddownJSON = {};
    },
    updateContentTS: function (ts) {
      const dd = this.dd;
      if (
        Math.floor(this.timestamp / DrillDown.DAYSECONDS) !==
        Math.floor(ts / DrillDown.DAYSECONDS)
      ) {
        //deal with time-travel outside of the day
        this.ddownJSON = {};
        this.doDD(dd.lonlat);
        return;
      }
      var currentDat = null;
      if (this.ddownJSON.dat !== undefined) {
        for (const d of this.ddownJSON.dat) {
          //.dat: [[ts, "date", downcount],...]
          if (d === null) continue;
          if (d[0] == ts) {
            currentDat = d;
            break;
          }
        }
      }
      if (currentDat !== null) {
        this.updateBlocks(currentDat[1], currentDat[2]);
      } else {
        //here if we don't have this time, we need to redo the drilldown
        console.log("no such time");
        this.ddownJSON = {};
        this.doDD(dd.lonlat);
      }
    },
    doDD: function (ll) {
      if (ll === null) return;
      const dd = this.dd;
      //xxx make sure use the same lon,lat order as in map
      const ts = dd.state.timestamp;
      const [lon, lat] = ll;
      dd.setLocation(ll);
      const jdata = this.ddownJSON;
      if (
        Math.abs(jdata.lat - lat) <= dd.state.grid / 2 &&
        Math.abs(jdata.lon - lon) <= dd.state.grid / 2
      ) {
        this.updateContentTS(ts); //still need to update sparkline text
        return;
      }
      this.clear();
      dd.callAJAX(lat, lon, ts, "dtli", this.ddCallback.bind(this));
    },
    ddCallback: function (ddown_json) {
      this.timestamp = ddown_json.ts;
      //make sure min and max are aligned to a day's boundary
      const day = this.timestamp - (this.timestamp % DrillDown.DAYSECONDS);
      const minTs = day + 659 - ((day + 659) % 660); // round up
      const maxTs =
        day +
        DrillDown.DAYSECONDS -
        1 -
        ((day + DrillDown.DAYSECONDS - 1) % 660); // round down
      const rndTs = this.timestamp - (this.timestamp % 660);
      const sldata = DrillDown.makeSLdata(minTs, maxTs, 660, ddown_json.dat);
      // Displaying words in popup
      if (sldata.oCount[rndTs] !== undefined && sldata.oCount[rndTs] !== null) {
        this.dd.updateContentTimeline(
          sldata.oCount[rndTs][1],
          sldata.oCount[rndTs][2],
        );
      } else {
        console.log(rndTs, minTs, maxTs, sldata.oCount);
      }
      this.ddownJSON = ddown_json;
      var sparkline = this.dd.addSparkline(
        sldata.barChart,
        sldata.allValues,
        ddown_json,
        this.jqSpark,
        "dtli",
      );
      // add x-axis labels
      const min_time = new Date(minTs * 1000)
        .toISOString()
        .substr(0, 16)
        .split("T")[1];
      const max_time = new Date(maxTs * 1000)
        .toISOString()
        .substr(0, 16)
        .split("T")[1];
      this.jqSparkLabels.html(
        `<p style="float:left;">${min_time}</p><p style="float:right;">${max_time}</p>`,
      );
      sparkline.unbind("sparklineClick"); //don't want to bind multiple times
      sparkline.bind(
        "sparklineClick",
        function (ev) {
          var region = ev.sparklines[0].getCurrentRegionFields();
          var click_dd = ddown_json.dat[region[0].offset];
          if (click_dd !== null) {
            var click_ts = click_dd[0];
            this.dd.timeTravel(click_ts);
          }
        }.bind(this),
      );
      this.updateContentTS(this.dd.state.timestamp);
    },
  },
  isp: {
    idx: -1,
    ddtype: "isp",
    timestamp: -1,
    ddownJSON: {},
    install: function (dd, idx) {
      this.dd = dd;
      this.idx = idx;
      this.jqLI = $(`<li><a href="#tabs-isp-${idx}">ISPs</a></li>`).appendTo(
        dd.jqTabsUL,
      );
      this.jqCt = $(`
        <div id="tabs-isp-${idx}" class="dd-tabs-isp">
          <div id="tabs-isp-${idx}-location" class="dd-tabs-location"></div>
          <div id="tabs-isp-${idx}-spark" class="dd-isp-spark-wrap"></div>
        </div>`).appendTo(dd.jqTabsCt);
      this.jqLocation = $(`#tabs-isp-${idx}-location`);
      this.jqSpark = $(`#tabs-isp-${idx}-spark`);
    },
    updateBlocks: function () {
      this.jqLocation.html(
        `Location: ${this.dd.coordStr} (${this.dd.state.grid}deg)`,
      );
    },
    clear: function () {
      this.jqSpark.html("Loading...");
      this.updateBlocks(null, null);
      this.ddownJSON = {};
    },
    updateContentTS: function (ts) {
      const dd = this.dd;
      this.updateBlocks(this.dd.lonlat[1], this.dd.lonlat[0]);
      if (ts !== this.ddownJSON.ts) {
        this.ddownJSON = {};
        this.doDD(dd.lonlat);
        return;
      }
    },
    percent: function (part, all) {
      return all === 0 ? 0 : Math.max(0, 100 * Math.min(1, part / all));
    },
    // ISP bar chart:
    // whole-bar ~ total count blocks in the ISP (scaled to total count of blocks)
    // colored-part ~ down count of blocks of the ISP (uses heatmap)
    // shaded-part ~ up count of blocks of the ISP (fixed gray)
    ispBarHtml: function (down, blocks, bct) {
      const upColor = "#77777766";
      const downColor = "rgba(" + heatmap(down, blocks) + ",0.9)";
      // lengths are controlled by html width with %'s: total is isp % in all blocks (blocks/bct)
      // down is inside the total, so % are relative to that, so down/blocks %
      const presencePct = this.percent(blocks, bct).toFixed(1);
      const downPct = this.percent(down, blocks).toFixed(1);
      return `
        <div class="dd-isp-bar-wrap" style="background:none;">
          <div class="dd-isp-bar-total" style="width:${presencePct}%; background:${upColor};">
            <div class="dd-isp-bar-down" style="width:${downPct}%; background:${downColor};"></div>
          </div>
        </div>`;
    },
    doDD: function (ll) {
      if (ll === null) return;
      const dd = this.dd;
      //xxx make sure use the same lon,lat order as in map
      const ts = dd.state.timestamp;
      const [lon, lat] = ll;
      dd.setLocation(ll);
      if (
        Math.abs(this.ddownJSON.lat - lat) <= dd.state.grid / 2 &&
        Math.abs(this.ddownJSON.lon - lon) <= dd.state.grid / 2 &&
        this.ddownJSON.ts === ts
      ) {
        this.updateContentTS(ts); //still need to update sparkline text
        return;
      }
      var jqSpark = this.jqSpark;
      jqSpark.html("Loading...");
      dd.callAJAX(
        lat,
        lon,
        ts,
        "isp",
        function (ddown_json) {
          this.ddownJSON = ddown_json;
          var dat = ddown_json.dat;
          if (dat.length === 0) {
            jqSpark.html(
              '<div style="color:rgba(255,255,255,0.7);font-size:10px;padding:4px;">No ISP data</div>',
            );
            return;
          }
          const total = dat.reduce(function (s, r) {
            return s + r[0];
          }, 0);
          const bct = ddown_json.bct ?? total;
          var totalPct = this.percent(total, bct);

          var html = `
          <div class="dd-isp-barchart">
            <div class="dd-isp-bar-row dd-isp-total-row">
              <div class="dd-isp-label">All ISPs</div>
              ${this.ispBarHtml(total, bct, bct)}
              <div class="dd-isp-value">${total} / ${bct} (${totalPct.toFixed(1)}%)</div>
            </div>`;

          // dat: [50 = isp_down_blocks, 40285 = asNUM, "NORTHLAND-CABLE, US" = asName, 55 = isp_total]
          var withMetrics = dat.map((row) => {
            const [down, asn, asname, blocks] = row;
            return {
              down: down,
              asn: asn,
              asname: asname,
              blocks: blocks,
              downPct: this.percent(down, blocks),
            };
          });

          // sort: down-block count, then downPct, then name
          withMetrics.sort(function (a, b) {
            if (b.down !== a.down) return b.down - a.down;
            if (b.downPct !== a.downPct) return b.downPct - a.downPct;
            return a.asname.localeCompare(b.asname);
          });

          withMetrics.forEach((isp) => {
            html += `
            <div class="dd-isp-bar-row">
              <div class="dd-isp-label" title="${isp.asname}">${isp.asname}</div>
                ${this.ispBarHtml(isp.down, isp.blocks, bct)}
              <div class="dd-isp-value">${isp.down} / ${isp.blocks} (${isp.downPct.toFixed(1)}%)</div>
            </div>`;
          });
          html += "</div>";
          jqSpark.html(html);
        }.bind(this),
      );
    },
  },
};

DrillDown.prototype.addTab = function (ddtype) {
  const idx = this.tabsObjList.length;
  const tabObj = Object.create(DrillDown.TABS[ddtype]);
  tabObj.install(this, idx);
  this.tabsObjList.push(tabObj);
  this.tabsObjDict[ddtype] = tabObj;
};

DrillDown.prototype.setHeatmap = function (colorScale, step) {
  this.heatmap = {};
  for (var n = 0; n < 100; n += step) {
    const range = n.toFixed(1) + ":" + (n + step - 0.1).toFixed(1);
    this.heatmap[range] = "rgba(" + heatmap(n * colorScale, 100) + ",.7)";
  }
  this.heatmap["100:"] = "rgba(" + heatmap(100 * colorScale, 100) + ",.7)";
};

DrillDown.prototype.closePopup = function () {
  this.overlay.setPosition(undefined);
  //this.overlay.setMap();
  this.popupCloser.blur();
  this.activeTab = -1;
  return false;
};

DrillDown.prototype.updateContentTimeline = function (
  blocks_change,
  blocks_total,
) {
  for (var tabObj of this.tabsObjList) {
    tabObj.updateBlocks(blocks_change, blocks_total);
  }
};

DrillDown.prototype.timeTravel = function (ts) {
  if (this.timeTravelRequest) this.timeTravelRequest(ts);
};

DrillDown.prototype.handleTimeout = function () {
  this.jqTimeout.show();
};

DrillDown.prototype.callAJAX = function (lat, lon, ts, ddtype, successHandler) {
  this.jqTimeout.hide();
  $.ajax({
    url: DrillDown.URL,
    type: "GET",
    cache: true,
    dataType: "json",
    data: {
      format: "json",
      lat: lat.toFixed(2),
      lon: lon.toFixed(2),
      grid: this.state.grid,
      qtype: ddtype,
      db: this.state.database,
      timestamp: ts,
    },
    context: this,
    timeout: 75000,
    error: this.handleTimeout.bind(this),
    success: successHandler,
  });
};

DrillDown.prototype.addSparkline = function (
  bar_chart,
  all_values,
  ddown_json,
  jqSpark,
  ddtype,
) {
  function ttFormatter(sl, op, f) {
    if (ddown_json.dat[f[0].offset] === null) {
      return "N/A";
    }
    var dateStr = "";
    if (ddtype == "ptli") {
      dateStr = new Date(ddown_json.dat[f[0].offset][0] * 1000)
        .toISOString()
        .substr(0, 16)
        .split("T")[0];
    } else if (ddtype == "dtli") {
      dateStr = new Date(ddown_json.dat[f[0].offset][0] * 1000)
        .toISOString()
        .substr(0, 16)
        .replace("T", " ");
    }
    return (
      '<span style="color: ' +
      f[0].color +
      ';">&#9632;  </span>' +
      f[0].value.toFixed(2) +
      "%<br>" +
      dateStr
    );
  }

  const barWidth = Math.min(4, 300 / bar_chart.length);
  jqSpark.sparkline(bar_chart, {
    type: "bar",
    barWidth: barWidth,
    colorMap: this.heatmap,
    lineColor: "",
    barSpacing: 0,
    tooltipFormat: "",
    height: 50,
    chartRangeMin: 0,
    tooltipFormatter: ttFormatter,
  });
  var dSparkline = jqSpark.sparkline(all_values, {
    composite: true,
    type: "line",
    lineColor: "white",
    fillColor: "",
    lineWidth: 2,
    highlightLineColor: "white",
    highlightSpotColor: "black",
    spotColor: "",
    minSpotColor: "",
    height: 50,
    width: 350,
    maxSpotColor: "",
    chartRangeMin: 0,
    tooltipFormat: "",
  });
  return dSparkline;
};

DrillDown.prototype.doDD = function (ddtype, ll) {
  var ddObj = this.tabsObjDict[ddtype];
  if (ddObj === undefined) {
    console.log(`Drilldown of type ${ddtype} is not supported`);
    return;
  }
  this.activeTab = ddObj.idx;
  this.jqTabs.tabs({ active: this.activeTab });
  this.setLocation(ll);
  this.lonlat = ll;
  ddObj.doDD(ll);
};

DrillDown.prototype.updateContentTS = function (ts) {
  if (this.activeTab < 0) return;
  if ("isp" in this.tabsObjDict) {
    const ispTab = this.tabsObjDict["isp"];
    if (this.state.dd_isp === false) {
      //if active, need to switch to first, as this tab is not available
      if (ispTab.idx == this.activeTab) {
        this.activeTab = this.tabsObjDict[this.defType].idx;
        this.jqTabs.tabs({ active: this.activeTab });
      }
      this.jqTabs.tabs("disable", ispTab.idx);
    } else {
      this.jqTabs.tabs("enable", ispTab.idx);
    }
  }
  //forward to the active tab
  this.tabsObjList[this.activeTab].updateContentTS(ts);
};

DrillDown.prototype.setLocation = function (ll) {
  //given a corner, display things at the center of the grid cell
  var llCenter = [ll[0] + this.state.grid / 2, ll[1] + this.state.grid / 2];
  var lon_direction = llCenter[0] < 0 ? "W" : "E";
  var lat_direction = llCenter[1] < 0 ? "S" : "N";
  //when displaying, display the center
  this.coordStr =
    Math.abs(llCenter[1]).toFixed(1) +
    lat_direction +
    ", " +
    Math.abs(llCenter[0]).toFixed(1) +
    lon_direction;
  this.state.ddown.lon = ll[0];
  this.state.ddown.lat = ll[1];
  $(this.popupContentTable).scrollTop(); //set the scroll bar back to the top
  //this.overlay.setMap(this.map);

  this.overlay.setPosition(fromLonLat(llCenter));
};

DrillDown.prototype.getURLState = function () {
  if (this.activeTab < 0) return "";
  var tab = this.tabsObjList[this.activeTab];
  var lon = this.state.ddown.lon.toFixed(1);
  var lat = this.state.ddown.lat.toFixed(1);
  return `&ddown=${tab.ddtype},${lon},${lat}`;
};

DrillDown.prototype.setURLState = function (str) {
  var ddVals = str.split(",");
  this.doDD(ddVals[0], [parseFloat(ddVals[1]), parseFloat(ddVals[2])]);
};

DrillDown.prototype._click = function (map, evt) {
  const clicked_features = [];
  const pois = this.pois;
  map.forEachFeatureAtPixel(
    evt.pixel,
    function (feature) {
      if (feature.ANTlabel === undefined) {
        //exclude hurricanes hack
        clicked_features.push(feature);
      }
    },
    {
      layerFilter: (layer) => layer === pois,
    },
  );

  if (clicked_features.length == 0) return;

  //find the closest feature center clicked on
  function featDistance(feat) {
    return new LineString([
      feat.getGeometry().getCenter(),
      evt.coordinate,
    ]).getLength();
  }
  var best_feature = clicked_features.shift();
  var best_distance = featDistance(best_feature);
  for (const f of clicked_features) {
    const d = featDistance(f);
    if (d < best_distance) {
      best_distance = d;
      best_feature = f;
    }
  }
  //convert coordinates to lon/lat format
  const llCenter = toLonLat(best_feature.getGeometry().getCenter());
  const llCorner = [
    llCenter[0] - this.state.grid / 2,
    llCenter[1] - this.state.grid / 2,
  ];

  this.lonlat = llCorner;

  // check whether isp tab is available
  if (this.tabsObjDict["isp"] !== undefined) {
    const ispTab = this.tabsObjDict["isp"];
    if (this.state.dd_isp == false) {
      if (this.activeTab === ispTab.idx) {
        this.activeTab = -1; //this will reset it to default
      }
      this.jqTabs.tabs("disable", ispTab.idx);
    } else {
      this.jqTabs.tabs("enable", ispTab.idx);
    }
  }
  let defTab;
  if (this.activeTab < 0) {
    //switch to default
    defTab = this.tabsObjDict[this.defType];
    this.activeTab = defTab.idx;
    this.jqTabs.tabs({ active: this.activeTab });
  } else {
    defTab = this.tabsObjList[this.activeTab];
  }
  defTab.doDD(llCorner);
  //this.jqTabs.tabs({ active: this.activeTab });
};

DrillDown.prototype.getOnClick = function (map) {
  return this._click.bind(this, map);
};

DrillDown.makeSLdata = function (minTs, maxTs, deltaTS, dat) {
  //reconstruct filled missing 0-down data
  var allValues = [];
  var barChart = [];
  var oCount = {}; //rounded_ts -> [ts, ocount, bcount]
  for (let ts = minTs; ts <= maxTs; ts += deltaTS) {
    oCount[ts] = null;
  }
  // value right away (not just to a day with max value)
  for (const d of dat) {
    //.dat: [[ts, downcount, bcount],...]
    let ts = d[0];
    ts -= ts % deltaTS;
    //round to a day
    oCount[ts] = d;
  }
  dat.length = 0; //this clears the array
  for (let ts = minTs; ts <= maxTs; ts += deltaTS) {
    const d = oCount[ts];
    if (d !== null) {
      const outage_percent = d[2] !== 0 ? (d[1] * 100) / d[2] : 0;
      allValues.push([d[0], outage_percent]);
      barChart.push(outage_percent);
    } else {
      allValues.push([ts, 0]);
      barChart.push(0);
    }
    dat.push(d);
  }
  return { oCount: oCount, barChart: barChart, allValues: allValues };
};
